import { useMemo } from 'react';
import FJTab from '../../../common/components/FJTab/FJTab';
import styles from './FJDisplayHeader.module.less';
// import CreationsIcon from '../../../assets/svg/image-small.svg?react';
// import HistoryIcon from '../../../assets/svg/history.svg?react';
// import ImageExtenderIcon from '../../../assets/svg/image-1.svg?react';
import FJConstant from '../../../constants/FJConstant';
import PropTypes from 'prop-types';
import FJAppConstant from '../../../constants/FJAppConstant';
import classNames from 'classnames';
import {
    HEADER_TAB_LIST,
    SHOW_COMMUNITY_LIST,
    SHOW_GENERATIONS_LIST,
} from '../../../config/dataConfig/FJCommonDataConfig';
import { useCallback } from 'react';

const FJDisplayHeader = props => {
    const {
        appType,
        onTabChange,
        selectedIndex,
        leftChildren,
        rightChildren,
        hideBottomLine = false,
        isPreDomNotPaddingBox = false,
        className,
    } = props;

    const headerTab = useMemo(() => {
        return HEADER_TAB_LIST.map(item => {
            const { type } = item;
            let isShow = true;
            switch (type) {
                case FJConstant.COMMUNITY:
                    isShow = SHOW_COMMUNITY_LIST.includes(appType);
                    break;
                case FJConstant.GENERATIONS:
                    isShow = SHOW_GENERATIONS_LIST.includes(appType);
                    break;
                default:
                    isShow = true;
                    break;
            }
            return {
                ...item,
                isShow,
            };
        }).filter(item => item.isShow);
    }, [appType]);
    const _onTabChange = useCallback(
        index => {
            const { type } = headerTab[index];
            onTabChange(type);
        },
        [onTabChange, headerTab],
    );
    const selectIdx = useMemo(() => {
        return headerTab.findIndex(item => item.type === selectedIndex);
    }, [headerTab, selectedIndex]);
    return (
        <div
            className={classNames(
                styles.header,
                {
                    [styles.not_padding_box]: isPreDomNotPaddingBox,
                    [styles.hide_bottom_line]: hideBottomLine,
                },
                className,
            )}
        >
            <div
                className={classNames(
                    styles.header_left,
                    appType === FJAppConstant.IMAGE_EXTENDER ||
                        appType === FJAppConstant.PHOTO_RESTORATION ||
                        appType === FJAppConstant.AI_HAIRSTYLE_CHANGER ||
                        appType === FJAppConstant.WATERMARK_REMOVER ||
                        appType === FJAppConstant.CLOTHES_CHANGER
                        ? styles.image_extender_header_left
                        : '',
                )}
            >
                {leftChildren}
            </div>
            <FJTab
                dataList={headerTab}
                selectedIndex={selectIdx}
                space={16}
                onChange={_onTabChange}
                lineClass={styles.header_line}
            />
            <div className={styles.header_right}>{rightChildren}</div>
        </div>
    );
};
FJDisplayHeader.propTypes = {
    appType: PropTypes.string,
    selectedIndex: PropTypes.number,
    onTabChange: PropTypes.func,
    hasStatus: PropTypes.bool,
    leftChildren: PropTypes.node,
    rightChildren: PropTypes.node,
    hideBottomLine: PropTypes.bool,
    isPreDomNotPaddingBox: PropTypes.bool,
    className: PropTypes.string,
};
export default FJDisplayHeader;
